/* EL: setas de scroll lateral para as listas (.el-scroll > .el-track). Sem dependências. */
(function () {
  if (window.__elScroll) return;
  window.__elScroll = true;

  function ligar(caixa) {
    if (caixa.__el) return;
    var pista = caixa.querySelector('.el-track');
    if (!pista) return;
    caixa.__el = true;
    var ant = caixa.querySelector('.el-arrow--prev');
    var seg = caixa.querySelector('.el-arrow--next');

    function atualizar() {
      var sobra = pista.scrollWidth - pista.clientWidth;
      caixa.setAttribute('data-overflow', sobra > 4 ? 'true' : 'false');
      if (ant) ant.disabled = pista.scrollLeft <= 2;
      if (seg) seg.disabled = pista.scrollLeft >= sobra - 2;
    }
    function andar(sentido) {
      pista.scrollBy({ left: sentido * pista.clientWidth * 0.8, behavior: 'smooth' });
    }
    if (ant) ant.addEventListener('click', function () { andar(-1); });
    if (seg) seg.addEventListener('click', function () { andar(1); });
    pista.addEventListener('scroll', atualizar, { passive: true });
    // apanha resize e também as tabs que passam de escondidas a visíveis
    if ('ResizeObserver' in window) new ResizeObserver(atualizar).observe(pista);
    else window.addEventListener('resize', atualizar);
    atualizar();
  }

  function arrancar() {
    document.querySelectorAll('.el-scroll').forEach(ligar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();
